exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\ntable[data-v-bcd4aea0] {\n  margin: auto;\n}\nbody>tr[data-v-bcd4aea0]:hover {\n  background-color: #ffcccc\n}\n.evenRow[data-v-bcd4aea0] {\n  background-color: #ffffcc\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-bcd4aea0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ManagementPage/EditLecturePage.vue
// module id = 546
// module chunks = 0